export class InvoiceList {
   public fileType : string;
   public contractNumber : string;
   public fileName : string;
   public invoiceFile : string;
   public encodedFile : string;       
}